// Banner API endpoints (RTK Query)
import baseApi, { apiTags } from '../api/baseApi'

const bannerApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    fetchActiveBanner: builder.query({
      providesTags: [apiTags.BANNER_ACTIVE],
      query: () => 'banner/active',
    }),

    fetchBannerList: builder.query({
      providesTags: [apiTags.BANNER_LIST],
      // Backend exposes the banner list at the /banner endpoint (returns array)
      query: () => 'banner',
      transformResponse: response => {
        // Backend returns an array directly or an object with a data property.
        const items = Array.isArray(response)
          ? response
          : response && Array.isArray(response.data)
            ? response.data
            : []

        return items.map(item => ({
          ...item,
          endDate: item.toDate ?? item.endDate,
          startDate: item.fromDate ?? item.startDate,
        }))
      },
    }),

    createBanner: builder.mutation({
      invalidatesTags: [apiTags.BANNER_LIST, apiTags.BANNER_ACTIVE],
      query: payload => ({
        body: payload,
        method: 'POST',
        url: 'banner',
      }),
    }),

    updateBanner: builder.mutation({
      invalidatesTags: [apiTags.BANNER_LIST, apiTags.BANNER_ACTIVE],
      query: ({ id, ...payload }) => ({
        body: payload,
        method: 'PUT',
        url: `banner/${id}`,
      }),
    }),

    deleteBanner: builder.mutation({
      invalidatesTags: [apiTags.BANNER_LIST, apiTags.BANNER_ACTIVE],
      query: id => ({
        method: 'DELETE',
        url: `banner/${id}`,
      }),
    }),
  }),
})

export const {
  useFetchActiveBannerQuery,
  useFetchBannerListQuery,
  useCreateBannerMutation,
  useUpdateBannerMutation,
  useDeleteBannerMutation,
} = bannerApi

export default bannerApi
